import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

const BASE_API_URL = '';

@Injectable({
  providedIn: 'root'
})
export class IptvDetailsService {
  constructor(private http: HttpClient) {

  }


  getCustomerIptvDetails(custId : any): Observable<any> {
    const get_url = BASE_API_URL + 'getCustomerIptvDetails/' + custId;
    return this.http.get<any>(get_url,{ headers: httpOptions.headers}).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }


  getIptvDetails(custId : any): Observable<any> {
    const get_url = BASE_API_URL + 'subscriber/getCustomerIptvDetails/' + custId;
    return this.http.get<any>(get_url,{ headers: httpOptions.headers}).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }



  updateIptvDetails(location_details_data): Observable<any> {
    const post_url = BASE_API_URL + 'subscriber/updateIptvBasicDetails';
    return this.http.post<any>(post_url,location_details_data,{ headers: httpOptions.headers}).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  addIptvDetails(data): Observable<any> {
    const post_url = BASE_API_URL + 'subscriber/addIptvDetails';
    return this.http.post<any>(post_url,data,{ headers: httpOptions.headers}).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  deleteIptvDetail(custId,id: any): Observable<any> {
    const delete_url = BASE_API_URL+"subscriber/deleteIptvDetail/" + custId + "/" + id;
    return this.http.delete(delete_url, httpOptions);
  }

}
